import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { createStripIntent } from "sr/utils/api/strip/createStripIntent";
import addCreditCard from "./addCreditCard";

interface ParamsType {
  customerId: string;
  currency: string;
  cardnumberElement: any;
  stripe: any;
  elements: any;
  email: string;
  cardcvv: any;
  cardExpiry: any;
  setCardDetails: (params: any) => void;
  setIsProcessing: (params: any) => void;
  stripId: string;
  setShowModel?: (params: any) => void;
  onCheckModel?: any;
  setSubmitError?: (msg: string | null) => void;
  setHighlightAllErrors?: (value: boolean) => void;
}

const CreateIntent = async (params: ParamsType) => {
  params?.setIsProcessing(true);
  if (!params?.cardnumberElement) {
  }
  if (params?.cardnumberElement) {
  }
  try {
    const payload = {
      // currency: params?.currency,
      // customer:params?.stripId
    };
    const res = await createStripIntent(payload);
    if (res?.success === true) {
      await addCreditCard({
        clientSecret: res?.data?.client_secret,
        setCardDetails: params?.setCardDetails,
        email: params?.email,
        setShowModel: params?.setShowModel,
        setIsProcessing: params?.setIsProcessing,
        stripId: params?.stripId,
        stripe: params?.stripe,
        elements: params?.elements,
        customerId: params?.customerId,
        cardnumberElement: params?.cardnumberElement,
        cardcvv: params?.cardcvv,
        cardExpiry: params?.cardExpiry,
        onCheckModel: params?.onCheckModel,
        setSubmitError: params?.setSubmitError,
        setHighlightAllErrors: params?.setHighlightAllErrors,
      });
    }
    // params?.setIsProcessing(false);
  } catch (e) {
    params.setIsProcessing(false);
    console.log("CreateIntent", e);
    HandleApiError(e);
  }
};
export default CreateIntent;
